import React from "react";
import { Input, Button, Checkbox, List } from "semantic-ui-react";

class CheckboxFilter extends React.Component {
  filterResults = (e, { name, value }) => {
    var filter, ul, li, a, i, txtValue;

    filter = value.toUpperCase();
    ul = document.getElementById("checkboxFilterList");
    li = ul.getElementsByClassName("item");
    for (i = 0; i < li.length; i++) {
      a = li[i].getElementsByTagName("label")[0];
      txtValue = a.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        li[i].style.display = "";
      } else {
        li[i].style.display = "none";
      }
    }
  };

  handleClick = (e, { value: val }) => {
    const { value, name } = this.props;
    let checked = value;
    val = +val;
    if (checked.indexOf(val) === -1) {
      checked.push(val);
    } else {
      checked.splice(checked.indexOf(val), 1);
    }
    this.props.onChange(e, { name: name, value: checked });
  };

  // Select All  button
  handleSelectAll = e => {
    const { name } = this.props;
    var iterator, ulist, list, element;
    ulist = document.getElementById("checkboxFilterList");
    list = ulist.getElementsByClassName("item");
    let checked = [];
    for (iterator = 0; iterator < list.length; iterator++) {
      if (list[iterator].style.display !== "none") {
        element = list[iterator].getElementsByTagName("input")[0];
        if (checked.indexOf(element.value) === -1) {
          checked.push(+element.value);
        }
      }
    }
    this.props.onChange(e, { name: name, value: checked });
  };

  //Deselect All  button
  handleDeselectAll = e => {
    const { value, name } = this.props;
    var iterator, ulist, list, element;
    ulist = document.getElementById("checkboxFilterList");
    list = ulist.getElementsByClassName("item");
    let checked = value;
    for (iterator = 0; iterator < list.length; iterator++) {
      if (list[iterator].style.display !== "none") {
        element = list[iterator].getElementsByTagName("input")[0];
        checked.splice(checked.indexOf(+element.value), 1);
      }
    }
    this.props.onChange(e, { name: name, value: checked });
  };
  render() {
    const { options, value } = this.props;
    return (
      <div id="checkboxFilterWrapper" tabIndex="0">
        <Input
          id="checkboxFilterQuery"
          onChange={this.filterResults}
          placeholder="Search for names.."
          autoComplete="off"
          icon="caret down"
          label={{ basic: true, content: `${value.length} selected` }}
          labelPosition="left"
          fluid
        />

        <div id="checkboxFilterOptions">
          <Button
            compact
            basic
            type="button"
            content="Select All"
            onClick={this.handleSelectAll}
          />
          <Button
            compact
            basic
            type="button"
            content="Deselect All"
            onClick={this.handleDeselectAll}
          />
          <List id="checkboxFilterList">
            {options.map((option, key) => (
              <List.Item key={`checkboxFilter-${option.value}`}>
                <Checkbox
                  label={option.text}
                  value={option.value}
                  checked={value.indexOf(option.value) > -1}
                  onChange={this.handleClick}
                />
              </List.Item>
            ))}
          </List>
        </div>
      </div>
    );
  }
}

export default CheckboxFilter;
